import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class AboutController {

  constructor(app) {
    this.app = app;
  }
  show(path, model) {
    model = this.getModel();

    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const config = app.config;

    let showRateGame = !config.hideRateGame;
    const model = {
      showRateGame: showRateGame,
    };

    return model;
  }
  //rate game button
  rateGame() {
    const app = this.app;
    app.rate();
  };
  email() {
    const app = this.app;
    app.feedback();
  }
  share() {
    const app = this.app;

    app.share("AboutPage");
  };
  communityPage() {

    var isAndroid = navigator.userAgent.match(/Android/i);
    var isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
    if (isIOS)
      window.open('fb://profile/847181962036765', '_system');
    else
      window.open('https://www.facebook.com/speedthecardgame', '_system');

    // window.open('https://www.facebook.com/speedthecardgame', '_blank', 'location=yes');
    // window.open('https://www.facebook.com/speedthecardgame', '_system');
    //window.open('https://www.facebook.com/847181962036765', '_system');
    // window.open('https://m.facebook.com/847181962036765', '_system');
  };

}